/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PersonalDataExposureCategory
 */
export interface PersonalDataExposureCategory {
  /**
   *
   * @type {number}
   * @memberof PersonalDataExposureCategory
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PersonalDataExposureCategory
   */
  name: string;
}

/**
 * Check if a given object implements the PersonalDataExposureCategory interface.
 */
export function instanceOfPersonalDataExposureCategory(value: object): value is PersonalDataExposureCategory {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function PersonalDataExposureCategoryFromJSON(json: any): PersonalDataExposureCategory {
  return PersonalDataExposureCategoryFromJSONTyped(json, false);
}

export function PersonalDataExposureCategoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PersonalDataExposureCategory {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
  };
}

export function PersonalDataExposureCategoryToJSON(value?: Omit<PersonalDataExposureCategory, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
  };
}
